var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row mb-3" }, [
    _c("div", { staticClass: "col-3" }, [
      _c("label", { attrs: { for: _vm.forInput } }, [
        _vm._v("\n            " + _vm._s(_vm.label) + "\n        ")
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-9" }, [_vm._t("default")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }